let client = {
    userinfo: {},
    callback: null,
    login: false,
    u: navigator.userAgent,
    isiOS: function () {
        return !!this.u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    },
    isAndroid: function () {
        return this.u.indexOf('Android') > -1 || this.u.indexOf('Adr') > -1
    },
    getSafari: function () {
        return this.u.match(/Safari\/([\S\s]+)/)
    },
    isWeiXin: function () {
        var ua = this.u.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        }
        return false;
    },
    isNfzm: function () {
        if (typeof JSBinder != "undefined") {
            return true;
        } else {
            return false;
        }
    },
    afterShare: function (callback) {
        if (typeof callback == "function") {
            this.callback = callback;
        }
    },
    fireShare: function (state, url) {
        if (this.callback != null) {
            this.callback(state, url);
        }
    },
    //设置app分享
    activityDetails: function (title, desc, img, url) {
        let s;
        if (typeof JSBinder != "undefined") {
            s = JSBinder.activityDetails(title, desc, img, url);
        }
        //alert(s)
        return (s == true || s == 'true')
    },
    gotoLogin: function () {
        if (typeof JSBinder != "undefined") {
            //$("body").html("<h4>请先退出该页面，再进入</h4>");
            var v = JSBinder.getVersion();
            var version = parseInt(v.replace(/\./g, ""));
            //alert(version);
            if (version < 522) {
                $("body").html("<h4>请先退出该页面，再进入</h4>");
            }
            JSBinder.gotoLogin();
        }
    },

    getParams: function () {
        if (this.isNfzm()) {
            this.userinfo["hash"] = JSBinder.getHash();
            this.userinfo["token"] = JSBinder.getToken() == "(null)" ? "" : JSBinder.getToken();
            this.userinfo["platform"] = JSBinder.getPlatform();
            this.userinfo["version"] = JSBinder.getVersion();
            this.userinfo["userid"] = "";
            this.userinfo["user"] = "";

            try {

                if (JSBinder.getUserId() !== "(null)" || JSBinder.getUsername() !== "") {
                    this.userinfo["userid"] = JSBinder.getUserId()
                } else {
                    if (this.userinfo["platform"] == "ireader") {
                        //iOS 旧版 userid 是 2276555
                        this.userinfo["userid"] = JSBinder.getUsername()
                    } else {
                        //Android user 是 2276555
                        this.userinfo["user"] = JSBinder.getUsername()
                    }
                }

            }
            catch (err) {
                if (this.userinfo["platform"] == "ireader") {
                    //iOS 旧版 userid 是 2276555
                    this.userinfo["userid"] = JSBinder.getUsername()
                } else {
                    //Android user 是 2276555
                    this.userinfo["user"] = JSBinder.getUsername()
                }

            }


            // if (this.userinfo["platform"] == "ireader") {
            //   //iOS
            //   this.userinfo["userid"] = (JSBinder.getUserId() == undefined) ? JSBinder.getUsername() : JSBinder.getUserId();
            // } else {
            //
            // }

            this.login = (JSBinder.getUsername() == "" || JSBinder.getUsername() == "(null)") ? false : true;

            this.userinfo["format"] = 'json';

            this.userinfo["night_mode"] = (typeof JSBinder.getNightMode == "function") ? (JSBinder.getNightMode() == "enable" ? true : false) : false;

            return this.userinfo
        } else {
            return false
        }
    },

    getUserInfo: function () {
        let that = this;
        return new Promise((resolve, reject) => {
            let int = setInterval(function () {
                try {
                    if ((typeof JSBinder) != "undefined") {
                        clearInterval(int);//清除定时执行
                        let userInfo, oldVersion, newVersion;
                        that.getAppParams().then((userInfo) => {
                            //console.log(userInfo);
                            oldVersion = {
                                'user': userInfo.user,
                                'token': userInfo.token,
                                'format': 'json'
                            };
                            newVersion = {
                                'userid': userInfo.userid,
                                'token': userInfo.token,
                                'format': 'json'
                            };

                            //alert(JSON.stringify(that))
                            resolve(userInfo.userid == '' ? oldVersion : newVersion)
                        })


                    } else {
                        //alert('nothing!!!')
                        //console.log('nothing!!!')
                    }
                } catch (err) {
                    reject(err)
                }
            }, 300)

        })
    },

    getAppParams: function () {
        let that = this;
        return new Promise((resolve, reject) => {
            let int = setInterval(function () {
                try {
                    if ((typeof JSBinder) != "undefined") {
                        that.getParams();
                        clearInterval(int)
                        //console.log(that.userinfo)
                        //alert(JSON.stringify(that))
                        resolve(that.userinfo)
                    } else {
                        //alert('nothing!!!')
                        //console.log('nothing!!!')
                    }
                } catch (err) {
                    reject(err)
                }
            }, 100)

        })
    }
}

window.JSafterShare = function (state, url) {
    if (typeof client.callback == "function") {
        client.fireShare(state, url);
    }
}

export default client



// WEBPACK FOOTER //
// ./resources/assets/redirect/client-promise.js